<template>
  <v-container grid-list-xl>
    <v-layout wrap>
      <v-flex sm4 xs12 md4 lg4>
        <material-stats-card
          color="green"
          icon="mdi-account-multiple-outline"
          title="Percentual de Ocupação"
          :value="percentage | formatCurrency"
          small-value="%"
          sub-icon="mdi-account-circle"
          :sub-text="numcustomers.toString() + ' membros'"
        />
      </v-flex>
      <!-- <v-flex
                sm3
                xs12
                md3
                lg3
            >
                <material-stats-card
                    color="orange"
                    icon="mdi-flash"
                    title="Percentual de Ocupação"
                    :value="percentage | formatCurrency"
                    small-value="%"
                    sub-icon="mdi-flag-variant"
                    sub-text="Ocupação Total da Usina"
                    sub-text-color="text-primary"
                />
            </v-flex> -->
      <v-flex sm4 xs12 md4 lg4>
        <material-stats-card
          color="orange"
          icon="mdi-flash"
          title="Em Cancelamento"
          :value="percentageCanceling | formatCurrency"
          small-value="%"
          sub-icon="mdi-flag-variant"
          :sub-text="numcustomersCanceling.toString() + ' membros'"
        />
      </v-flex>
      <!-- <v-flex
                sm4
                xs12
                md4
                lg4
            >
                <material-stats-card
                    color="orange"
                    icon="mdi-flash"
                    title="Cancelados"
                    :value="percentageCanceled | formatCurrency"
                    small-value="%"
                    sub-icon="mdi-flag-variant"
                    :sub-text="numcustomersCanceled.toString() + ' membros'"
                    sub-text-color="text-primary"
                />
            </v-flex> -->
      <v-flex sm4 xs12 md4 lg4>
        <material-stats-card
          color="#095F96"
          icon="mdi-credit-card"
          title="Percentual de Cartões"
          :value="(percentagecards * 100) | formatCurrency"
          small-value="%"
          sub-icon="mdi-flag-variant"
          sub-text="Membros com cartão cadastrado"
          sub-text-color="text-primary"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { EventBus } from "../../utils/event-bus";

export default {
  data: () => ({
    percentage: 0,
    percentageCanceling: 0,
    percentageCanceled: 0,
    numcustomers: 0,
    numcustomersAtivos: 0,
    numcustomersCanceling: 0,
    numcustomersCanceled: 0,
    percentagecards: 0,
    loading: false,
  }),
  mounted() {
    EventBus.$on("LoadCustomers", (customers) => {
      this.loading = true;
      var count_customers = customers.reduce(function (sum, value) {
        // if(value.user.card_default || value.user.boleto_accepted_at) {
        if (
          value.percentage &&
          value.percentage * 1 > 0 &&
          value.status === "activated"
        ) {
          return sum + 1;
        } else {
          return sum;
        }
        // } else {
        //     return sum
        // }
      }, 0);
      this.numcustomers = count_customers;

      var count_customersCanceling = customers.reduce(function (sum, value) {
        // if(value.user.card_default || value.user.boleto_accepted_at) {
        if (
          value.percentage &&
          value.percentage * 1 > 0 &&
          value.status === "canceling"
        ) {
          return sum + 1;
        } else {
          return sum;
        }
        // } else {
        //     return sum
        // }
      }, 0);
      this.numcustomersCanceling = count_customersCanceling;

      // var count_customersCanceled = customers.reduce(function(sum, value) {
      //     // if(value.user.card_default || value.user.boleto_accepted_at) {
      //         if(value.percentage && value.percentage*1 > 0 && value.status === 'canceled') {
      //             return sum + 1
      //         } else {
      //             return sum
      //         }
      //     // } else {
      //     //     return sum
      //     // }
      // }, 0);
      // this.numcustomersCanceled = count_customersCanceled

      var sum_percent = customers.reduce(function (sum, value) {
        // if(value.user.card_default || value.user.boleto_accepted_at) {
        if (
          value.percentage &&
          value.percentage * 1 > 0 &&
          value.status === "activated"
        ) {
          return sum + value.percentage * 1;
        } else {
          return sum;
        }
        // } else {
        //     return sum
        // }
      }, 0);
      this.percentage = parseFloat(sum_percent).toFixed(2);

      var sum_percent_canceling = customers.reduce(function (sum, value) {
        // if(value.user.card_default || value.user.boleto_accepted_at) {
        if (
          value.percentage &&
          value.percentage * 1 > 0 &&
          value.status === "canceling"
        ) {
          return sum + value.percentage * 1;
        } else {
          return sum;
        }
        // } else {
        //     return sum
        // }
      }, 0);
      this.percentageCanceling = parseFloat(sum_percent_canceling).toFixed(2);

      // var sum_percent_canceled = customers.reduce(function(sum, value) {
      //     console.log(value.status)
      //     // if(value.user.card_default || value.user.boleto_accepted_at) {
      //         if(value.percentage && value.percentage*1 > 0 && value.status === 'canceled') {
      //             return sum + (value.percentage * 1)
      //         } else {
      //             return sum
      //         }
      //     // } else {
      //     //     return sum
      //     // }
      // }, 0);
      // this.percentageCanceled = parseFloat(sum_percent_canceled).toFixed(2)

      var sum_percent_cards = customers.reduce(function (sum, value) {
        if (
          value.user.card_default &&
          value.user.card_default !== null &&
          value.status === "activated"
        ) {
          return sum + 1;
        } else {
          return sum;
        }
      }, 0);
      this.percentagecards = parseFloat(
        sum_percent_cards / customers.length,
      ).toFixed(2);
      this.loading = false;
    });
  },
};
</script>
